module.exports = __webpack_public_path__ + "img/filter_close.27bb7df5.svg";